import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { DashboardDataProvider } from "../../data-provider/dashboard.dp";
import { Dashboard } from "../../models/dashboard.model";
import { PermissionCheck } from "../../shared/permission";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { DashboardWidgetFilter } from "../../models/dashboard-widget-filter.model";

let DashboardFiltersComponent = {
    selector: "vcDashboardFilters",
    templateUrl:
        "/angular/components/dashboard/dashboard-filters.component.html",
    bindings: {
        filter: "=",
        dashboard: "=",
        size: "=?",
    },
    controller: class DashboardFiltersController {
        // * bindings for typescript compiler *
        public dashboard: Dashboard;
        public filter: DashboardWidgetFilter;
        public size: string;
        // ************************************

        private readonly $scope: any;
        private dialog: DialogUtils;

        constructor($scope: any, DialogUtils: DialogUtils) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
        }

        $onInit() {
            this.filter.dateRange = {};
            if (!this.size) {
                this.size = "default";
            }
        }

        openFiltersDialog(filter: DashboardWidgetFilter, ev: any) {
            this.dialog
                .show({
                    component: "vc-widget-filter-dialog",
                    targetEvent: ev,
                    scope: this.$scope,
                    clickOutsideToClose: false,
                    ariaLabel: "Dashboard Filters",
                    locals: {
                        filter: angular.copy(filter),
                        title: this.dashboard.referenceName() + " Filters",
                        dashboard: this.dashboard,
                        global: true,
                    },
                })
                .then((returnedFilter: DashboardWidgetFilter) => {
                    this.filter.setData(returnedFilter);
                });
        }
    },
};

angular
    .module("dashboard")
    .component(DashboardFiltersComponent.selector, DashboardFiltersComponent);
